<template>
    <div class="luckDraw" id="sss" :class="{isShare: isShare}">
        <template v-if="isShare == 1">
            <img :src="require(`@/assets/img/activity/worldCup/${realIndex}.png`)" alt="">
            <div id="qrBox"></div>
        </template>
        <template v-else>
            <headSssembly title="即享世界杯 嗨翻全场" v-if="isJH"/>
            <van-notice-bar
                left-icon="volume-o"
                :text="actionRadio"
            />
            <div class="step">
                <div>
                    <img src="@/assets/img/activity/worldCup/share.png" alt="">
                    <p>
                        <em>分享好友卡片</em>
                    </p>
                </div>
                <div>
                    <img src="@/assets/img/activity/worldCup/friends.png" alt="">
                    <p>
                        <em>好友助力</em>
                    </p>
                </div>
                <div>
                    <img src="@/assets/img/activity/worldCup/luckDraw.png" alt="">
                    <p>
                        <em>开始抽奖</em>
                    </p>
                </div>
                <div>
                    <img src="@/assets/img/activity/worldCup/redEnvelopes.png" alt="">
                    <p>
                        <em>获得奖励</em>
                    </p>
                </div>
            </div>
            <div class="prizeBox">
                <div class="num">
                    <div class="numImg" :class="{position: falgFontSize}">
                        {{frequency}}
                    </div>
                </div>
                <div class="turntable">
                    <div class="turntableBox">
                        <template v-if="jackpot">
                            <div class="coupon"
                                :class="{all: index != 4,
                                turn: index === 4,
                                // turnFalse: index === 4 && frequency == 0,
                                model: item.type == 'model' && item.data_type != 31  && item.data_type != 32 && index !== 4,
                                back: item.type == 'coupon' && index !== 4,
                                qiuyi: item.type == 'attires',
                                vip: item.type == 'model' && item.data_type == 31 || item.type == 'model' && item.data_type == 32  && index !== 4,
                            }"
                            v-for="(item, index) in jackpot" :key="index" @click="loot(index)">
                                <template v-if="index === 4">
                                    <strong>开始</strong>
                                    <strong>抽奖</strong>
                                    <span>{{unlockNum}}人已抽奖</span>
                                </template>
                                <!-- <template v-else-if="index == 8"></template> -->
                                <template v-else>
                                    <p v-if="item.type == 'coupon'">
                                        <em>{{item.amount / 100}}</em><span>嗨币</span>
                                    </p>
                                    <p v-else-if="item.type == 'attires'">
                                        球衣一件
                                    </p>
                                    <p v-else-if="item.type == 'model' && item.data_type != 31 && item.data_type != 32">
                                        模型<em>{{item.days}}</em>天
                                    </p>
                                    <p v-else>
                                        会员<em>{{item.days}}</em>天
                                    </p>
                                    <p>{{item.use_type_name}}</p>
                                </template>
                            </div>
                        </template>
                        <template v-else>
                            <img class="imgBack" @click="refresh" src="@/assets/img/activity/worldCup/backMo.jpeg" alt="">
                        </template>
                    </div>
                </div>
                <div class="btn">
                    <div @click="goRule">
                        <img src="@/assets/img/activity/worldCup/btn1.png" alt="">
                    </div>
                     <div @click="gpMyData">
                        <img src="@/assets/img/activity/worldCup/btn3.png" alt="">
                    </div>
                    <div @click="gpMyCoupon">
                        <img src="@/assets/img/activity/worldCup/btn2.png" alt="">
                    </div>
                </div>
            </div>
            <van-overlay :show="show" style="z-index: 100">
                <div class="wrapper" v-if="alretModelData && alretModelData.type == 'coupon'">
                    <div class="redEnvelopes">
                        <div class="left">
                            <p>余额：</p>
                            <p>
                                <em>{{alretModelData.amount / 100}}</em>嗨币
                            </p>
                        </div>
                        <div class="right">
                            <div class="top">
                                <div class="leftText">
                                    <p>{{alretModelData.amount / 100}}嗨币通用红包</p>
                                    <span>世界杯活动奖励</span>
                                    <span>{{alretModelData.use_type_name}}</span>
                                </div>
                                <div class="rightText">
                                    <span @click="gpMyCoupon">立即使用</span>
                                </div>
                            </div>
                            <div class="bottom">
                                有效期{{alretModelData.valid_start.substring(0, 10).replace(/-/g, '/')}}-{{alretModelData.valid_end.substring(0, 10).replace(/-/g, '/')}}
                            </div>
                        </div>
                    </div>
                    <div class="priceNum">{{alretModelData.amount / 100}}</div>
                    <div class="btn" @click="show = false"></div>
                </div>
            </van-overlay>
            <van-overlay :show="modelHuodong" style="z-index: 100">
                <!-- <div class="wrapper wrapperModel" >
                    <div class="content">
                        <p>恭喜您获得模型</p>
                        <p><em>30</em>天有效期</p>
                    </div>
                    <div class="btn" @click="show = false"></div>
                </div> -->
                <div class="wrapper wrapperModel" v-if="alretModelData && alretModelData.type != 'coupon'">
                    <div class="content">
                        <p>恭喜您获得{{alretModelData.use_type_name}}模型</p>
                        <p><em>{{alretModelData.days}}</em>天有效期</p>
                    </div>
                    <div class="btn" @click="modelHuodong = false"></div>
                </div>
            </van-overlay>
            <div class="swiperCard">
                <div class="title"></div>
            </div>
            <div class="swiperBox">
                <div class="swiper-container">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide">
                            <img src="@/assets/img/activity/worldCup/1.png" alt="">
                            <div id="qrcode" class="qrcode" ref="codeItem"></div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/img/activity/worldCup/2.png" alt="">
                            <div id="qrcode" class="qrcode" ref="codeItem"></div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/img/activity/worldCup/3.png" alt="">
                            <div id="qrcode" class="qrcode" ref="codeItem"></div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/img/activity/worldCup/4.png" alt="">
                            <div id="qrcode" class="qrcode" ref="codeItem"></div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/img/activity/worldCup/5.png" alt="">
                            <div id="qrcode" class="qrcode" ref="codeItem"></div>
                        </div>
                        <div class="swiper-slide">
                            <img src="@/assets/img/activity/worldCup/6.png" alt="">
                            <div id="qrcode" class="qrcode" ref="codeItem"></div>
                        </div>
                    </div>
                    <!-- Add Pagination -->
                    <div class="swiper-pagination"></div>
                </div>
            </div>
            <div class="bottomInvitation">
                <div class="userList">
                    <div class="headPortrait">
                        <template v-if="inviteList">
                            <img v-for="(item, index) in inviteList" :key="index" :src="item.avatar" alt="">
                            <template v-if="inviteList.length == 1">
                                <img src="@/assets/img/activity/worldCup/moren.png" alt="">
                                <img src="@/assets/img/activity/worldCup/moren.png" alt="">
                            </template>
                            <template v-if="inviteList.length == 2">
                                <img src="@/assets/img/activity/worldCup/moren.png" alt="">
                            </template>
                        </template>
                        <template v-else>
                            <img src="@/assets/img/activity/worldCup/moren.png" alt="">
                            <img src="@/assets/img/activity/worldCup/moren.png" alt="">
                            <img src="@/assets/img/activity/worldCup/moren.png" alt="">
                        </template>
                    </div>
                    <div class="numberOfPeople">
                        <span>{{inviteNum}}人</span>
                        <span>累计助力</span>
                    </div>
                </div>
                <div class="icon">
                    <div @click="share(1)"><img src="@/assets/img/common/iconSaveImg.png" alt=""></div>
                    <div @click="share(2)"><img src="@/assets/img/common/iconSharePyq.png" alt=""></div>
                    <div @click="share(3)"><img src="@/assets/img/common/iconShareWx.png" alt=""></div>
                </div>
            </div>
            <div class="bottomInvitationstation"></div>
            <van-popup v-model="showModel" :lazy-render='false'>
                <div class="showModelBox" @click.stop>
                    <div class="top">
                        前往客户端即可参与活动，新用户可还可获得88嗨币红包哦~
                    </div>
                    <div class="bottom">
                        <div @click="showModel = false">稍后前往</div>
                        <div id="h5">前往客户端</div>
                    </div>
                </div>
            </van-popup>
            <van-popup v-model="showModelLuckDraw" :lazy-render='false'>
                <div class="showModelBox" @click.stop>
                    <div class="top">
                        当前暂无抽奖机会，首次充值或者邀请好友注册可获得抽奖机会哦～
                    </div>
                    <div class="bottom">
                        <div @click="goRecharge">去充值（{{rechargeNum > 1 ? '1' : rechargeNum}}/1）</div>
                        <div @click="share(1)">立即邀请</div>
                    </div>
                </div>
            </van-popup>
            <van-popup v-model="showCompletePayment" :lazy-render='false'>
                <div class="showModelBox" @click.stop>
                    <div class="top">
                        <p>
                            支付完成前，请不要关闭此支付验证窗口
                        </p>
                        <p>
                            支付完成后，请根据您支付的情况点击下面按钮
                        </p>
                    </div>
                    <div class="bottom">
                        <div @click="refresh">支付遇到问题</div>
                        <div @click="refresh">支付完成</div>
                    </div>
                </div>
            </van-popup>
        </template>
    </div>
</template>

<script>
import headSssembly from "@/components/common/headSssembly"
import { isLogin, isJHApp, isJHAppios } from "@/utils/base";
import { buildQrCode, importSdk } from "@/utils/tools";
import Swiper from "swiper"
import { worldCuplIndex, worldCupRaffle, getUserInfo, rechargeClick } from "@/api/activity.js"
import jsbridg from "@/utils/jsbridg.js"
export default {
    name: "luckDraw",
    components: {
        headSssembly
    },
    data () {
        return {
            isJH: isJHApp(),
            isShare: this.$route.query.isShare,
            isStart: true,
            time: null,
            speed: 100,
            index: 0,
            save: null,
            count: 0,
            num: 0,
            show: false,
            frequency: 0,
            swiper: null,
            jackpot: null,
            inviteNum: 0,
            unlockNum: 0,
            actionRadio: "",
            typeStyle: {
                all: 'back',
                pay_group: 'model',
                news: true
            },
            typeStyleModel: {
            },
            choiceType: "",
            sourceData: null,
            alretModelData: "",
            inviteList: null,
            arrImg: [1, 2, 3, 4, 5, 6],
            uid: '',
            showModel: false,
            realIndex: this.$route.query.realIndex || 1,
            showModelLuckDraw: false,
            showCompletePayment: false,
            rechargeNum: 0,
            modelHuodong: false
        };
    },
    watch: {
        show (news) {
            if (!news) {
                this.isStart = true
                this.time = null
                this.speed = 100
                this.index = 0
                this.save = null
                this.count = 0
                this.num = 0
            }
        },
        modelHuodong (news) {
            if (!news) {
                this.isStart = true
                this.time = null
                this.speed = 100
                this.index = 0
                this.save = null
                this.count = 0
                this.num = 0
            }
        }
    },
    created () {
        this.getJackpot()
        document.getElementsByTagName('title')[0].innerHTML = "即享世界杯 嗨翻全场"
    },
    computed: {
        falgFontSize () {
            if (this.frequency > 10) {
                return true
            } else {
                return false
            }
        }
    },
    mounted () {
        // this.loot()
        this.initSwiper()
        if (isJHApp()) {
            jsbridg.hideAppBar(0);
            this.getUserInfo().then(() => {
                this.setBindQRCode()
            })
        } else {
            const btn = document.getElementById('sss');
            btn.style.visibility = "visible";
            btn.onclick = () => {
                this.showModel = true
            }
            this.$nextTick(() => {
                importSdk("https://web.cdn.openinstall.io/openinstall.js", this.initOpenInstall);
            })
        }
    },
    methods: {
        refresh () {
            window.location.reload()
        },
        goRule () {
            jsbridg.goWebview({
                url: process.env.VUE_APP_DOMAIN + '/activity/worldCup/rule',
                jumptype: 2
            });
        },
        gpMyCoupon () {
            if (isLogin()) {
                if (isJHApp()) {
                    jsbridg.goWebview({
                        url: process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step14',
                        jumptype: 2
                    });
                } else {
                    window.open(process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step14');
                }
            } else {
                jsbridg.jhAppLogin()
            }
        },
        gpMyData () {
            if (isLogin()) {
                if (isJHApp()) {
                    jsbridg.goWebview({
                        url: process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step41',
                        jumptype: 2
                    });
                } else {
                    window.open(process.env.VUE_APP_H5_DOMAIN + '/page/new_my#step41');
                }
            } else {
                jsbridg.jhAppLogin()
            }
        },
        async rechargeClick () {
            const res = await rechargeClick()
            if (res.errno === 0) {
            } else {
                this.$toast(res.errmsg)
            }
        },
        goRecharge () {
            this.rechargeClick()
            if (isJHApp()) {
                this.showCompletePayment = true
                if (isJHAppios()) {
                    jsbridg.appiosPay();
                    return;
                }
                jsbridg.goWebview({
                    // url: process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=buy',
                    url: process.env.VUE_APP_DOMAIN + '/user/recharge',
                    jumptype: 2
                });
            } else {
                window.open(process.env.VUE_APP_H5_DOMAIN + '/page/new_pay?ordertype=buy');
            }
        },
        initOpenInstall () {
            /* eslint-disable*/
            var data = OpenInstall.parseUrlParams();///openinstall.js中提供的工具函数，解析url中的所有查询参数
            data.jump_info = {
                jump_url: 2,
                url: process.env.VUE_APP_DOMAIN + `/activity/worldCup/luckDraw?top_bar_style=2`,
                params: '',
                code: 9,
                jumptype: 2
            }
            const that = this
            data.yxPath = window.location.href;
            new OpenInstall({
                /*appKey必选参数，OpenInstall平台为每个应用分配的ID*/
                appKey: process.env.VUE_APP_OPENINSTALLAPPKEY,
                onready: function () {
                    /*在app已安装的情况尝试拉起app*/
                    this.schemeWakeup();
                    /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                    var m = this;
                    var btn_1 = document.getElementById('h5');
                    // var btn_2 = document.getElementById('origin');
                    if (btn_1) {
                        btn_1.style.visibility = "visible";
                        btn_1.onclick = function() {
                            m.wakeupOrInstall();
                            return false;
                        }
                    }
                    // btn_2.style.visibility = "visible";
                    // btn_2.onclick = function() {
                    //     m.wakeupOrInstall();
                    //     return false;
                    // }
                }
            }, data);
        },
        async getUserInfo () {
            const res = await getUserInfo()
            if (res.errno === 0) {
                this.uid = res.data.uid
            }
        },
        setBindQRCode () {
            const path = process.env.VUE_APP_DOMAIN + `/activity/worldCup/luckDraw?channelCode=sjbhd1&invite_uid=` + this.uid;
            var style =
                document.documentElement.currentStyle ||
                document.defaultView.getComputedStyle(document.documentElement, "");
            let fs = style.fontSize.replace("px", "");
            let size = (fs * 3.75) / 2;
            buildQrCode(path, size, 'qrBox')
            // this.$nextTick(() => { 
            //     this.arrImg.forEach((item,index)=>{
            //         this.$refs.codeItem[index].innerHTML="";
            //         const path = process.env.VUE_APP_DOMAIN + `/activity/worldCup/luckDraw?channelCode=sjbhd1&invite_uid=` + this.uid;
            //         buildQrCode(path, 70, this.$refs.codeItem[index])
            //     });                          
            // },500)
        },
        share (type) {
            if (isLogin()) {
                const str = window.location.href
                let flag = '?'
                str.split('').forEach((item) => {
                    if (item === '?') {
                        flag = '&'
                    }
                })
                if (type === 1) {
                    jsbridg.imgShare(window.location.href + `${flag}isShare=1&realIndex=${this.swiper.realIndex + 1}`)
                }
                if (type === 2) {
                    jsbridg.imgShare(window.location.href + `${flag}isShare=1&realIndex=${this.swiper.realIndex + 1}`)
                }
                if (type === 3) {
                    jsbridg.imgShare(window.location.href + `${flag}isShare=1&realIndex=${this.swiper.realIndex + 1}`)
                }
             } else {
                jsbridg.jhAppLogin()
            }
        },
        async getJackpot () {
            const res = await worldCuplIndex()
            if (res.errno === 0 && res.data) {
                this.sourceData = JSON.parse(JSON.stringify(res.data.prize_list))
                res.data.prize_list.splice(4, 0, {})
                this.jackpot = res.data.prize_list
                this.frequency = res.data.draw_num
                this.inviteNum = res.data.invite_num
                this.unlockNum = res.data.unlock_num
                this.rechargeNum = res.data.recharge_num
                if (res.data.invite_list) {
                    this.inviteList = res.data.invite_list
                }
                if (res.data.notice_list && res.data.notice_list.length > 0) {
                    let str = ""
                    res.data.notice_list.forEach((item, index) => {
                        if (index + 1 !== res.data.notice_list.length) {
                            str += item + '\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0'
                        }
                    })
                    this.actionRadio = str
                }
            } else {
                this.$toast(res.errmsg)
            }
        },
        initSwiper () {
            this.swiper = new Swiper('.swiper-container', {
                slidesPerView: 1.4999,
                spaceBetween: 1,
                centeredSlides: true,
                loop: true,
                autoplay: {
                    disableOnInteraction: false,
                    delay: 5000
                },
                // autoplayDisableOnInteraction : false, 
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                slideToClickedSlide: true
            });
        },
        async worldCupRaffle () {
            const res = await worldCupRaffle()
            if (res.errno === 0) {
                this.choiceType = res.data
            } else {
                this.$toast(res.errmsg)
                // this.choiceType = {
                //     type: 'model',
                //     data_type: 31,
                //     days: 30
                // }
            }
        },
        Rotate () {
            var item = document.querySelectorAll(".all");
            if (this.num >= item.length) {
                this.num = 0;
                this.count++;
            }
            if (this.save) {
                this.save.classList.remove("ck");
            }
            item[this.num].classList.add("ck");
            this.save = item[this.num];
            // 对speed速度进行设置
            if (this.count < 6) {
                this.speed -= 2;// 提速
            } else {
                // 大于等于5圈,开始减速
                this.speed += 30;
            }
            // 限制speed最小值
            if (this.speed <= 10) {
                this.speed = 10;
            }
            if (this.count >= 8 && this.num === this.index) {
                clearTimeout(this.time);
                if (this.choiceType.type == 'coupon') {
                    this.show = true
                } else {
                    this.modelHuodong = true
                }
                return;
            }
            this.num++;
            this.time = setTimeout(this.Rotate, this.speed);
        },
        loot (index) {
            if (isLogin()) {
                if (index === 4) {
                    if (this.isStart && this.frequency > 0) {
                        this.isStart = false;
                        this.worldCupRaffle().then(() => {
                            this.frequency--
                            this.sourceData.forEach((item, index) => {
                                // eslint-disable-next-line eqeqeq
                                if (item.type == this.choiceType.type) {
                                    if (this.choiceType.type == 'attires') {
                                        this.index = index
                                        this.alretModelData = item
                                    } else if (this.choiceType.type == 'model') {
                                        if (item.data_type == this.choiceType.data_type) {
                                            if (item.days == this.choiceType.days) {
                                                this.index = index
                                                this.alretModelData = item
                                            }
                                        }
                                    } else if (this.choiceType.type == 'coupon') {
                                        if (item.amount == this.choiceType.amount) {
                                            this.index = index
                                            this.alretModelData = item
                                        }
                                    }
                                }
                            })
                            this.Rotate();
                        })
                    } else {
                        if (isJHApp()) {
                            this.showModelLuckDraw = true
                        }
                    }
                }
            } else {
                jsbridg.jhAppLogin()
            }
        }
    }
}
</script>

<style lang="less" scoped>
@font-face {
    font-family: YouSheBiaoTiHei;
    src: url("../../../../public/font/YouSheBiaoTiHei-2.ttf");
}
.luckDraw{
    min-height: 100vh;
    background-image: url("../../../assets/img/activity/worldCup/back.png");
    background-size: 100% 100%;
    /deep/.van-notice-bar{
        background: rgba(0, 0, 0, 0.1);
        height: 28px;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
    }
    /deep/.van-overlay{
        z-index: 100 !important;
    }
    .step{
        height: 87px;
        display: flex;
        align-items: center;
        padding: 0 15px;
        div{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            img{
                width: 45px;
                height: 45px;
            }
            p{
                font-size: 12px;
                font-weight: 400;
                color: #FCF4DD;
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                em{
                    flex: 1;
                    text-align: center;
                }
                &::after{
                    content: '';
                    width: 7px;
                    height: 12px;
                    background-image: url("../../../assets/img/activity/worldCup/Arraw.png");
                    background-size: 100% 100%;
                }
            }
            &:last-child{
                p{
                    &::after{
                        display: none;
                    }
                }
            }
        }
    }
    .prizeBox{
        background-image: url("../../../assets/img/activity/worldCup/box.png");
        background-size: 100% 100%;
        height: 403px;
        .num{
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 14px;
            padding-top: 50px;
            .numImg{
                background: url("../../../assets/img/activity/worldCup/text.png");
                background-size: 100% 100%;
                width: 190px;
                height: 18.5px;
                font-size: 30px;
                font-weight: normal;
                color: #FFCE00;
                display: flex;
                align-items: center;
                padding-left: 50px;
            }
            .position{
                padding-left: 47px;
            }
        }
        .turntable{
            height: 255px;
            margin-top: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            .turntableBox{
                width: 255px;
                height: 255px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                align-content: space-between;
                .coupon{
                    width: 79px;
                    height: 80.5px;
                    p{
                        &:first-child{
                            height: 59px;
                            font-size: 13px;
                            font-weight: 600;
                            color: #FFFFFF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            padding-top: 5px;
                            em{
                                font-size: 25px;
                                margin-bottom: 5px;
                            }
                        }
                        &:last-child{
                            font-size: 11px;
                            font-weight: 600;
                            color: #169AFF;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            margin-top: 2px;
                        }
                    }
                }
                .imgBack{
                    width: 255px;
                    height: 258px;
                }
                .model{
                    background: url("../../../assets/img/activity/worldCup/overseas.png");
                    // background: #FCF4DD;
                    background-size: 100% 100%;
                    p{
                        &:last-child{
                            color: #169AFF;
                        }
                    }
                }
                .turn{
                    background: linear-gradient(180deg, #FFA427 0%, #FF3122 100%);
                    border-radius: 5px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    strong{
                        font-size: 22px;
                        color: #FFFFFF;
                        font-weight: bold;
                        line-height: 25px;
                        text-shadow: 0px 2px 0px #960A00;
                    }
                    span{
                        font-size: 11px;
                        font-weight: 400;
                        color: #FFFFFF;
                        margin-top: 5px;
                    }
                }
                .turnFalse{
                    background: linear-gradient(180deg, #B5B5B5 0%, #515151 100%);
                }
                .ck{
                    position: relative;
                    &::before{
                        position: absolute;
                        z-index: 1;
                        background: url("../../../assets/img/activity/worldCup/active.png");
                        background-size: 100% 100%;
                        content: '';
                        top: -1px;
                        left: -1px;
                        width: 81px;
                        height: 81px
                    }
                }
                .back{
                    background: url("../../../assets/img/activity/worldCup/haibi.png");
                    background-size: 100% 100%;
                    p{
                        &:last-child{
                            color: #FF5901;
                        }
                    }
                }
                .qiuyi{
                    background: url("../../../assets/img/activity/worldCup/qiuyi.png");
                    background-size: 100% 100%;
                    p{
                        &:last-child{
                            color: #790DA4;
                        }
                    }
                }
                .vip{
                    background: url("../../../assets/img/activity/worldCup/vip.png");
                    background-size: 100% 100%;
                    p{
                        &:last-child{
                            color: #DA251C;
                        }
                    }
                }
                .thankYou{
                    background: url("../../../assets/img/activity/worldCup/thankYou.png");
                    background-size: 100% 100%;
                }
            }
        }
        .btn{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 30px;
            padding-top: 30px;
            div{
                img{
                    width: 90px;
                    height: 30px;
                }
            }
        }
    }
    /deep/.van-overlay{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .wrapper{
        background: url("../../../assets/img/activity/worldCup/redEnvelopeBulletBox.png");
        background-size: 100% 100%;
        padding-top: 90px;
        height: 395px;
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        .redEnvelopes{
            height: 98px;
            width: 277px;
            background: url("../../../assets/img/activity/worldCup/couponBack.png");
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            .left{
                width: 85px;
                height: 100%;
                padding-left: 5px;
                display: flex;
                flex-direction: column;
                p{
                    font-size: 13px;
                    line-height: 30px;
                    font-weight: 400;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    em{
                        font-size: 40px;
                        font-weight: normal;
                        color: #FFFFFF;
                    }
                }
            }
            .right{
                flex: 1;
                height: 100%;
                padding-left: 5px;
                .top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding-right: 10px;
                    height: 60px;
                    .leftText{
                        display: flex;
                        flex-direction: column;
                        p{
                            font-size: 14px;
                            font-weight: 500;
                            color: #333333;
                        }
                        span{
                            font-size: 11px;
                            font-weight: 400;
                            color: #666666;
                        }
                    }
                    .rightText{
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        span{
                            width: 50px;
                            height: 22px;
                            background: #DA251C;
                            border-radius: 2px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 11px;
                            font-weight: 400;
                            color: #FFFFFF;
                            margin-bottom: 2px;
                        }
                    }
                }
                .bottom{
                    font-size: 11px;
                    font-weight: 400;
                    color: #666666;
                    display: flex;
                    align-items: center;
                    height: 15px;
                }
            }
        }
        .priceNum{
            font-size: 40px;
            font-weight: 600;
            color: #FFF1DF;
            text-shadow: 1px 3px 0px #8B0700;
            margin-top: 90px;
            margin-right: 60px;
            font-style: oblique;
            // padding-left: 155px;?
            // width: 100%;
        }
        .btn{
            width: 188px;
            height: 46px;
            background: url("../../../assets/img/activity/worldCup/btnAlert.png");
            background-size: 100% 100%;
            margin-top: -5px;
        }
    }
    .wrapperModel{
        background: url("../../../assets/img/activity/worldCup/modelBack.png");
        background-size: 100% 100%;
        height: 350px;
        .content{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding-top: 120px;
            margin-bottom: 10px;
            p{
                font-size: 28px;
                font-family: YouSheBiaoTiHei;
                color: #FFF1DF;
                line-height: 37px;
                text-shadow: 1px 2px 0px #8B0700;
                display: flex;
                align-items: center;
                justify-content: center;
                em{
                    font-size: 40px;
                    margin-top: -1px;
                }
            }
        }
    }
    .swiperCard{
        display: flex;
        justify-content: center;
        .title{
            background: url("../../../assets/img/activity/worldCup/nav.png");
            background-size: 100% 100%;
            height: 31px;
            width: 315px;
        }
        padding: 24px 0 20px 0;
    }
    .swiperBox{
        height: 410px;
        width: 100%;
        .swiper-container {
            width: 100%;
            height: 100%;
        }
        .swiper-slide {
            text-align: center;
            font-size: 18px;
            height: 336px;
            /* Center slide text vertically */
            display: -webkit-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-box-pack: center;
            -ms-flex-pack: center;
            -webkit-justify-content: center;
            justify-content: center;
            -webkit-box-align: center;
            -ms-flex-align: center;
            -webkit-align-items: center;
            align-items: center;
            transition: 300ms;
            transform: scale(0.8);
            position: relative;
            .qrcode{
                position: absolute;
                right: 10px;
                bottom: 8px;
            }
            img{
                width: 100%;
                height: 100%;
            }
        }
        .swiper-slide-active,.swiper-slide-duplicate-active{
            transform: scale(1);
        }
        .swiper-pagination{
            bottom: 30px;
            /deep/.swiper-pagination-bullet{
                width: 8px;
                height: 8px;
                background: #FFFFFF;
                opacity: 1;
            }
            /deep/.swiper-pagination-bullet-active{
                background: #CCCCCC;
            }
        }
    }
    .bottomInvitation{
        z-index: 20;
        position: fixed;
        bottom: 0;
        width: 100%;
        padding-bottom: 15px;
        background: #fff;
        display: flex;
        align-items: center;
        height: 56px;
        padding: 0 5px;
        >div{
            flex: 1
        }
        .userList{
            display: flex;
            align-items: center;
            border-right: 1px solid #CCCCCC;
            .headPortrait{
                padding: 0 9px;
                width: 110px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 25px;
                    height: 25px;
                }
            }
            .numberOfPeople{
                padding-right: 9px;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                span{
                    font-size: 12px;
                    font-weight: 400;
                    color: #333333;
                }
            }
        }
        .icon{
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-left: 15px;
            padding-right: 10px;
            div{
                img{
                    width: 40px;
                    height: 40px;
                }
            }
        }
    }
    .bottomInvitationstation{
        height: 71px;
    }
    /deep/.van-popup{
        border-radius: 8px 8px 8px 8px; 
    }
    .showModelBox{
        width: 290px;
        height: 157px;
        border-radius: 8px 8px 8px 8px;
        .top{
            height: 112px;
            padding: 0 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            p {
                font-size: 14px;
                text-align: left;
            }
        }
        .bottom{
            height: 45px;
            border-top: 1px solid #EEEEEE;
            display: flex;
            align-items: center;
            div{
                flex: 1;
                height: 100%;
                font-size: 15px;
                font-weight: 400;
                color: #333333;
                display: flex;
                align-items: center;
                justify-content: center;
                &:last-child{
                    border-left: 1px solid #EEEEEE;
                    color: #DA251C;
                }
            }
        }
    }
}
.isShare{
    min-height: auto !important;
    background: none !important;
    position: relative;
    #qrBox{
        position: absolute;
        right: 16px;
        bottom: 21px;
    }
}
@import url("../../../assets/css/swiper.min.css");
</style>
